// Dados fictícios — site de demonstração. Nenhuma informação de contato é real.

export const WHATSAPP_DISPLAY = "+55 (83) 99876-5432";
export const WHATSAPP_NUMBER = "5583998765432";

export const waLink = (message) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const WHATSAPP_DEFAULT = waLink(
    "Olá! Gostaria de agendar um horário na Corte Nobre Barbearia.",
);

export const PHONE_DISPLAY = "(83) 99876-5432";
export const PHONE_LINK = "tel:+5583998765432";

export const ADDRESS = "Av. Almirante Tamandaré, 1420 — Tambaú";
export const ADDRESS_CITY = "João Pessoa - PB, 58039-010";
export const MAPS_LINK =
    "https://www.google.com/maps/search/?api=1&query=Tamba%C3%BA%2C%20Jo%C3%A3o%20Pessoa%20-%20PB";

export const INSTAGRAM_HANDLE = "@cortenobre.pb";

export const NAV_LINKS = [
    { label: "Início", href: "#inicio" },
    { label: "Serviços", href: "#servicos" },
    { label: "Galeria", href: "#galeria" },
    { label: "Depoimentos", href: "#depoimentos" },
    { label: "Contato", href: "#contato" },
];

export const HOURS = [
    { days: "Segunda a Sexta", time: "09:00 — 20:00" },
    { days: "Sábado", time: "08:00 — 19:00" },
    { days: "Domingo e Feriados", time: "Fechado", note: "Atendimento VIP sob agendamento" },
];

export function getOpenStatus() {
    const now = new Date();
    const d = now.getDay();
    const h = now.getHours() + now.getMinutes() / 60;
    if (d === 0) return { open: false, label: "Fechado no momento" };
    const range = d === 6 ? { o: 8, c: 19 } : { o: 9, c: 20 };
    const open = h >= range.o && h < range.c;
    return { open, label: open ? "Aberto agora" : "Fechado no momento" };
}

export const HERO_IMG =
    "https://images.unsplash.com/photo-1572663459735-75425e957ab9?auto=format&fit=crop&w=1920&q=80";

export const GALLERY_ITEMS = [
    {
        src: "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?auto=format&fit=crop&w=1400&q=80",
        label: "O Ritual do Corte",
        span: "md:col-span-7 md:row-span-2",
    },
    {
        src: "https://images.pexels.com/photos/16372646/pexels-photo-16372646.jpeg?auto=compress&cs=tinysrgb&w=1200",
        label: "Cadeira Clássica",
        span: "md:col-span-5 md:row-span-2",
    },
    {
        src: "https://images.unsplash.com/photo-1599351431202-1e0f0137899a?auto=format&fit=crop&w=1000&q=80",
        label: "Precisão na Navalha",
        span: "md:col-span-4",
    },
    {
        src: "https://images.unsplash.com/photo-1647140655214-e4a2d914971f?auto=format&fit=crop&w=1000&q=80",
        label: "Detalhes que Definem",
        span: "md:col-span-4",
    },
    {
        src: "https://images.pexels.com/photos/10775081/pexels-photo-10775081.jpeg?auto=compress&cs=tinysrgb&w=1000",
        label: "Barboterapia",
        span: "md:col-span-4",
    },
    {
        src: "https://images.unsplash.com/photo-1605497788044-5a32c7078486?auto=format&fit=crop&w=1000&q=80",
        label: "Finalização Premium",
        span: "md:col-span-5",
    },
    {
        src: "https://images.pexels.com/photos/4625626/pexels-photo-4625626.jpeg?auto=compress&cs=tinysrgb&w=1200",
        label: "Ambiente Nobre",
        span: "md:col-span-7",
    },
];

export const scrollToId = (hash) => {
    const el = document.querySelector(hash);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -70, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};
